<template>
  <v-expansion-panels flat accordion>
    <v-expansion-panel>
      <v-expansion-panel-header class="white--text" color="purple accent-4"
        >New DOTS Activity</v-expansion-panel-header
      >
      <v-expansion-panel-content>
        <form method="POST">
          <v-row>
            <v-col cols="4">
              <label for>DOTS Start Date</label>
              <date-picker
                @clearDate="data.dots_startdate = null"
                :date="data.dots_startdate"
                v-model="data.dots_startdate"
              />
            </v-col>
            <v-col cols="4">
              <label>Volunteer</label>
              <v-select
                v-model="data.volunteer_id"
                :items="volunteers"
                item-value="id"
                dense
                outlined
              >
                <template slot="selection" slot-scope="data">
                  <!-- HTML that describe how select should render selected items -->
                  {{ data.item.code }} ({{ data.item.name }})
                </template>
                <template slot="item" slot-scope="data">
                  <!-- HTML that describe how select should render items when the select is open -->
                  {{ data.item.code }} ({{ data.item.name }})
                </template>
              </v-select>
            </v-col>
            <v-col cols="4">
              <label>DOTS App Status</label>

              <v-select
                v-model="data.dots_app_status"
                :items="[
                  { value: 1, text: `No` },
                  { value: 2, text: `Yes` },
                ]"
                item-text="text"
                item-value="value"
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <div class="d-flex justify-end">
            <v-btn class="form-btn" @click="$emit(`submitForm`, data)">
              <v-icon left>mdi-chevron-right-circle-outline</v-icon>Submit
            </v-btn>
          </div>
        </form>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapState } from "vuex";
import DatePicker from "@/components/common/DatePicker";
export default {
  components: { DatePicker },
  data: () => ({}),
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          dots_startdate: "",
          dots_app_status: "",
          volunteer_id: "",
        };
      },
    },
  },
  created() {
    this.$store.dispatch("Volunteer/getVolunteers");
  },
  computed: {
    ...mapState("Volunteer", ["volunteers"]),
  },
};
</script>

<style></style>
